import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"secondary","small":_vm.$vuetify.breakpoint.smAndDown,"block":_vm.block},on:{"click":_vm.goBack}},[_c(VIcon,{attrs:{"left":""}},[_vm._v(_vm._s(_vm.backIcon))]),_vm._v(" Go Back ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }